export class Utilidades {
  public static focus(elemento: HTMLElement) {
    if (!elemento || !(elemento instanceof HTMLElement))
      return;

    elemento.focus();
  }

  public static homologarEstado(estado: string): string {
    switch (estado) {
      case 'EN_PROCESO':
        return 'En proceso';
      case 'DEVOLUCION':
        return 'Con devolución';
      case 'DEVOLUCION_SUBSANADA':
        return 'Devuelta y corregida';
      case 'RECHAZADO':
        return 'Rechazada';
      case 'APROBADO_PARCIAL':
        return 'Aprobada parcialmente';
      case 'APROBADO':
        return 'Aprobada';
      case 'COMPLETADO_PARCIAL':
        return 'Completada parcialmente';
      case 'COMPLETADO':
        return 'Completada';
      case 'EN_VALIDACION_INTERNA':
        return 'En validación interna';
      case 'COMPLETADO_MANUAL':
        return 'Completada manualmente';
      default:
        return 'Estado desconocido';
    }
  }

  public static clasificarEstadoHomologacion(estado: string, data: any): string {
    const regex = /^[A-Za-z0-9]+-[A-Za-z0-9]{4}-[A-Za-z0-9]{3}-[A-Za-z0-9]{3}-[A-Za-z0-9]{2}$/;
    if (!regex.test(data?.radicado) && data?.tipoAfiliacion === 4) {
      const enTramite = ['PENDING', 'BLOQUEO_SAP'];
      const rechazado = ['DEVOLUTION', 'DUPLICIDAD', 'ACTUALIZACION_OPERATIVA', 'RECHAZADO'];
      const aprobado = ['APPROBATION', 'APROBADO_PARCIAL', 'APROBADO_MANUAL'];

      if (enTramite.includes(estado)) {
        return 'En trámite';
      } else if (rechazado.includes(estado)) {
        return 'Rechazado';
      } else if (aprobado.includes(estado)) {
        return 'Aprobado';
      } else {
        return estado;
      }
    }

    const enTramite = ['EN_PROCESO', 'EN_VALIDACION_INTERNA', 'APROBADO_PARCIAL', 'APROBADO', 'PENDING', 'APROBADO_MANUAL'];
    const conObservaciones = ['DEVOLUCION', 'DEVOLUCION_SUBSANADA', 'COMPLETADO_PARCIAL', 'DEVOLUTION'];
    const rechazado = ['RECHAZADO'];
    const aprobado = ['COMPLETADO', 'COMPLETADO_MANUAL', 'APPROBATION'];

    if (enTramite.includes(estado)) {
      return 'En trámite';
    } else if (conObservaciones.includes(estado)) {
      return 'Con observaciones';
    } else if (rechazado.includes(estado)) {
      return 'Rechazado';
    } else if (aprobado.includes(estado)) {
      return 'Aprobado';
    } else {
      return estado;
    }
  }

  public static clasificarEstado(estado: string): string {
    const enTramite = ['EN_PROCESO', 'EN_VALIDACION_INTERNA', 'APROBADO_PARCIAL', 'APROBADO', 'PENDING', 'APROBADO_MANUAL'];
    const conObservaciones = ['DEVOLUCION', 'DEVOLUCION_SUBSANADA', 'COMPLETADO_PARCIAL', 'DEVOLUTION'];
    const rechazado = ['RECHAZADO'];
    const aprobado = ['COMPLETADO', 'COMPLETADO_MANUAL', 'APPROBATION'];

    if (enTramite.includes(estado)) {
      return 'En trámite';
    } else if (conObservaciones.includes(estado)) {
      return 'Con observaciones';
    } else if (rechazado.includes(estado)) {
      return 'Rechazado';
    } else if (aprobado.includes(estado)) {
      return 'Aprobado';
    } else {
      return estado;
    }
  }

  public static limpiarTexto(valor: any): string {
    return (valor ?? "")
      .toString()
      .trim()
      .replace(/\s+/g, " ");
  }
}
